import React from "react";
import {FormContext} from '../../dynamic-form/dynamic-form-context';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

export default function DisabledComponentField({metadata}){

  const style = {
    border: "1px solid #B5B5B5",
    height: "32px",
    width: "100%",
    borderRadius: '2px',
    marginBottom: '20px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    paddingLeft: '10px',
  };

  const {formValues, setFormValues} = React.useContext(FormContext);

  const handleChange = (event) => {
    setFormValues(metadata.name, event.target.value, 1)
  };

  return (
    <Select
      style={style}
      value={((formValues[metadata.name] || {})["value"] || '')}
      onChange={handleChange}
      MenuProps={{
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left",
        },
        disablePortal: true
      }}
    >
      {metadata.options.map((component, index) => {
        const key = Object.keys(component)[0];
        const value = Object.values(component)[0];
        return (
          <MenuItem key={index} value={key}>
            {value}
          </MenuItem>
        );
      })}
    </Select>
  );
}